<template>
  <div class="main_wrapper">
    <div class="rewards-wrapper">
      <span class="main-header">{{ $t('cashback.recompensas') }}</span>

      <div class="main-layout" v-if="hasInitialRewards">
        
        <div class="featured-card" :class="{ 'no-button': !showClickButton }">
          <div class="day-tag-large">DIA 1</div>
          <div class="featured-content">
            <div class="featured-currency">R$</div>
            <div class="featured-amount">{{ formatCurrency(dayList[0].amount) }}</div>
            
            <button 
              v-if="showClickButton" 
              class="action-button" 
              @click="clickOnButton"
            >
             {{ $t('cashback.conquistar') }}
            </button>
            
            <div class="availability-status">
              <div class="check-circle">✓</div>
              <span> {{ $t('cashback.disponivel') }}</span>
            </div>
          </div>
        </div>
        
        <div class="grid-container featured-grid-area">
          <div class="rewards-grid-4">
            <div v-for="(item, index) in featuredList" :key="index" class="grid-card">
              <div class="day-tag-small">DIA {{ index + 2 }}</div>
              <div class="grid-card-content">
                <img src="@/assets/common/box.png" class="chest-img" alt="Chest" />
                <div class="item-date">{{ dayFormat(item.date, 0) }}</div>
                <div class="item-value">R$ {{ formatCurrency(item.amount) }}</div>
              </div>
            </div>
          </div>
        </div> 
      </div>

      <div v-if="overflowList.length > 0" class="overflow-section">
        <div class="grid-container" style="padding-bottom: 10px;">
          <div class="rewards-grid-6">
            <div v-for="(item, index) in overflowList" :key="index" class="grid-card">
              <div class="day-tag-small">DIA {{ index + 10 }}</div>
              <div class="grid-card-content">
                <img src="@/assets/common/box.png" class="chest-img" alt="Chest" />
                <div class="item-date">{{ dayFormat(item.date, 0) }}</div>
                <div class="item-value">R$ {{ formatCurrency(item.amount) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="stats-footer">
        <div class="stats-label">{{ $t('cashback.ganhos') }}</div>
        <div class="stats-value-row">
          <img src="@/assets/common/left_coin.png" class="coin-stack" alt="Coins" />
          <span class="total-amount-text">R$ {{ formatCurrency(availableValue) }}</span>
          <img src="@/assets/common/right_coin.png" class="coin-stack" alt="Coins" />
        </div>
        <div class="stats-sub">{{ $t('cashback.totalBonus') }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { computed, PropType } from 'vue';

const props = defineProps({
  showClickButton: { type: Boolean, default: true },
  availableValue: { type: Number, default: 0.00 },
  dayList: {
    type: Array as PropType<any[]>,
    default: () => getDefaultRewards() 
  }
});
console.log("Day list",props.dayList)
const emits = defineEmits(['getClaim']);
const clickOnButton = () => emits('getClaim');

const hasInitialRewards = computed(() => props.dayList && props.dayList.length > 0);

const featuredList = computed(() => {
  return props.dayList ? props.dayList.slice(1, 9) : [];
});

const overflowList = computed(() => {
  return props.dayList ? props.dayList.slice(9) : [];
});
</script>

<style scoped>
.main_wrapper{
  padding: 0px 15px 15px;
}
.rewards-wrapper {
  background: #0000008c;
  padding: 10px 10px;
  border-radius: 15px;
  color: #fff;
  font-family: 'Inter', sans-serif;
  max-width: 850px;
  margin: auto;
}

.main-header {
  display: flex;
  text-align: center;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 700;
  justify-content: center;
  color: #89b8ff
}

.main-layout {
  display: flex;
  gap: 9px;
  margin-bottom: 10px;
  align-items: flex-start;
}

/* --- YOUR ORIGINAL FEATURED CARD CSS --- */
.featured-card {
  border: 2px solid #084e87;;
  border-radius: 10px;
  position: relative;
  width: 33%;
  height: 9.9rem;
  padding-bottom: 1.5vh;
 background: linear-gradient(180deg, 
  rgba(6, 19, 57, 0.9) 0%,
  rgba(8, 78, 135, 0.4) 50%,
  rgba(5, 12, 38, 0.6) 100%
);
  box-shadow: 0px 0px 7px 5px #084e87e8;
}

.featured-card.no-button {
  height: 9.9rem;
}

.day-tag-large {
    background: #75bcf5;
    color: #000;
    font-weight: 700;
    font-size: 15px;
    padding: 4px 10px;
    width: fit-content;
    border-bottom-right-radius: 15px;
    border-top-left-radius: 7px;
}

.featured-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
}

.featured-currency {
  font-size: 20px;
  color: #89b8ff;
  font-weight: 600;
}

.featured-amount {
  font-size: 30px;
  font-weight: 700;
  color: #FBD67C;
  text-shadow: 0 0 15px rgba(255, 206, 166, 0.5);
  line-height: 1.1;
  margin-bottom: 11px;
}

.action-button {
    width: 91%;
    background: #89b8ff;
    border: none;
    border-radius: 50px;
    padding: 9px 0px;
    font-weight: 700;
    color: #1a0f0a;
    cursor: pointer;
    font-size: 9px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    margin-bottom: 8px;
}

.availability-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(0.9375rem, 0.9rem + 0.15vw, 1.0625rem);
  color: #89b8ff;
}

.check-circle {
    background: #89b8ff;
    color: #FFF;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.grid-container {
  /* background-color: #ffffff05; */
  /* border: 1px solid rgba(255, 255, 255, 0.05); */
  /* padding: 10px; */
  border-radius: 10px;
}

.featured-grid-area {
  width: 70%;
  /* Removed height: 25vh to allow it to match the featured-card or grow naturally */
}

.overflow-section {
  width: 100%;
  margin-top: 10px;
}

.rewards-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.rewards-grid-6 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

.grid-card {
  background: #061339;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #084e87;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 7px 5px #084e8738;
}

.day-tag-small {
    background: #75bcf5;
    color: #000;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    width: fit-content;
    border-bottom-right-radius: 10px;
}

.grid-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 8px;
}

.chest-img {
  width: 45px;
  height: auto;
  margin-bottom: 4px;
}

.item-date {
  font-size: 10px;
  color: #8a8a8e;
  font-weight: 500;
}

.item-value {
  font-size: 10px;
  font-weight: 700;
  color: #E3DCC7;
  margin-top: 2px;
}

/* Footer Stats */
.stats-footer {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.stats-label {
  font-size: 13px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 8px;
}

.stats-value-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.total-amount-text {
  font-size: 25px;
  font-weight: 700;
  color: #fbd67c; 
  background: radial-gradient(circle, rgb(119 64 120 / 0%) 0%, #3b67ff4d 139%);
  padding: 5px 15px;
  border-radius: 5px;
}

.coin-stack {
  width: 30px;
}

.stats-sub {
  font-size: 13px;
  color: #ccc;
  margin-top: 8px;
}
</style>